module.exports = __webpack_public_path__ + "static/img/right3.deb121f2.png";